import React, { useState } from 'react';
import styled from 'styled-components';
import { ControlledReactCounterInput } from 'components/react-counterInput/react-counterInput';

/* #region styles */
const StyledControlledReactCounterInput = styled(ControlledReactCounterInput)`
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    color: ${({ theme }) => theme.ColorTextPrimary};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.ColorBorderPrimary};
    border-radius: ${({ theme }) => theme.RadiusMedium};
`;

/* #endregion */
export default function PagingInput({
    currentPageNumber,
    onBlur,
    numberOfPages
}: {
    currentPageNumber: number;
    onBlur: (page: number) => void;
    numberOfPages: number;
}) {
    const [pagingInputValue, setPagingInputValue] = useState(currentPageNumber);

    return (
        <StyledControlledReactCounterInput
            size="lg"
            value={pagingInputValue}
            adjustCountButtons={false}
            minValue={1}
            maxValue={numberOfPages}
            onValueChange={(value) => setPagingInputValue(value)}
            onBlur={(value) => onBlur(value)}
            onEnter={(value) => onBlur(value)}
            autoFocus
        />
    );
}
